/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from "react";
import moment from "moment";
import { format } from "date-fns";
import TableCell from "../../../components/TableCell";

export const ITEM_TRANSACTION_COLUMNS = (
  withoutItem,
  params,
  editable,
  deleteRow,
  editRow,
  posted,
  Auth
) => {
  let columns = [
    {
      Header: "Status",
      accessor: "Posted",
      id: "Posted",
      sortType: (a, b) => {
        const aVal = a.original.Posted;
        const bVal = b.original.Posted;
        if (aVal) return 1;
        if (bVal) return -1;
        return 0;
      }
    },
    {
      Header: "Date",
      accessor: "TransDt",
      id: "TransDt",
      Cell: ({ cell }) =>
        cell.value
          ? moment(new Date(cell.value).toISOString().slice(0, 10)).format(
              "MM/DD/YYYY"
            )
          : null
    },
    {
      Header: "Item Number",
      accessor: "ItemNo",
      id: "ItemNo"
    },
    {
      Header: "Item Description",
      accessor: "ItemDescription",
      id: "ItemDescription"
    },
    {
      Header: "Type",
      accessor: "TransType",
      id: "TransType"
    },
    {
      Header: "Quantity",
      accessor: "Quantity",
      id: "Quantity",
      Cell: ({ cell }) => (
        <TableCell.Number value={JSON.stringify(cell.value)} />
      )
    }
  ];
  if (Auth) {
    columns = [
      ...columns,
      {
        Header: "Cost",
        accessor: "Cost",
        id: "Cost",
        Cell: ({ cell }) => (
          <TableCell.Currency value={JSON.stringify(cell.value)} />
        )
      },
      {
        Header: "Extension",
        accessor: "Extension",
        id: "Extension",
        Cell: ({ cell }) => (
          <TableCell.Currency value={JSON.stringify(cell.value)} />
        )
      }
    ];
  }
  columns = [
    ...columns,
    {
      Header: "Batch",
      accessor: "BatchNo",
      id: "BatchNo",
      Cell: ({ cell }) => <TableCell.Number value={cell.value} />
    },
    {
      Header: "GP Batch",
      accessor: "GpBatchNo",
      id: "GpBatchNo",
      Cell: ({ cell }) => <TableCell.Number value={cell.value} />
    },
    {
      Header: "Location",
      accessor: "LocName",
      Cell: ({ cell }) => cell.value || " "
    },
    {
      Header: "PO Number",
      accessor: "PONo",
      id: "PONo",
      Cell: ({ cell }) => <TableCell.Number value={cell.value} />
    },
    {
      Header: "Vendor Name",
      accessor: "VendorName",
      id: "Vendor",
      Cell: ({ cell }) => cell.value || " "
    },
    {
      Header: "Trans Note",
      accessor: "TransNote",
      id: "TransNote",
      Cell: ({ cell }) => cell.value || " "
    },
    {
      Header: "Created By",
      accessor: "CreatedBy",
      id: "CreatedBy"
    },
    {
      Header: "Created On",
      accessor: "CreatedDateTime",
      id: "CreatedDateTime",
      Cell: ({ cell }) =>
        cell.value ? format(new Date(cell.value), "MM/dd/yyyy") : null
    }
  ];

  if (params && params.RecId && params.UsePrimaryStorageDimension)
    columns.splice(
      columns.findIndex(({ id }) => id === "PONo"),
      0,
      {
        Header: `${params.PrimaryStorageDimension.CodeDescription}`,
        accessor: "InvDim1Code",
        Cell: ({ cell }) => cell.value || " "
      }
    );

  if (params && params.RecId && params.UseSecondaryStorageDimension)
    columns.splice(
      columns.findIndex(({ id }) => id === "PONo"),
      0,
      {
        Header: `${params.SecondaryStorageDimension.CodeDescription}`,
        accessor: "InvDim2Code",
        Cell: ({ cell }) => cell.value || " "
      }
    );

  if (params && params.RecId && params.UseTertiaryStorageDimension)
    columns.splice(
      columns.findIndex(({ id }) => id === "PONo"),
      0,
      {
        Header: `${params.TertiaryStorageDimension.CodeDescription}`,
        accessor: "InvDim3Code",
        Cell: ({ cell }) => cell.value || " "
      }
    );

  if (withoutItem) {
    columns.splice(1, 2);
  }
  columns.splice(
    columns.findIndex(({ id }) => id === "PONo"),
    0,
    {
      Header: "WO No.",
      accessor: "WorkOrder",
      id: "WorkOrder",
      Cell: obj => {
        if (obj.data) {
          const item = obj.data.find(d => d.WorkOrder === obj.cell.value);
          return (
            <TableCell.Link
              to={`/fleet/work-orders/${item.WorkOrderRecIdRef}/parts`}
              value={`#${obj.cell.value}`}
            />
          );
        }
        return obj.cell.value;
      }
    }
  );

  if (editable) {
    if (!posted) {
      columns.splice(0, 0, {
        Header: "Delete",
        Cell: obj => deleteRow(obj)
      });
      columns.splice(0, 0, {
        Header: "Edit",
        Cell: obj => editRow(obj)
      });
    }
  }
  return columns;
};
